/**
 * @generated SignedSource<<d4dbbcc69c670f4a216d87568dde837a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogArticleCardFragment$data = {
  readonly blurHash: string | null | undefined;
  readonly createdAt: string;
  readonly firstAuthor: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"EntityAvatarFragment">;
    }>;
  };
  readonly id: string;
  readonly image: any | null | undefined;
  readonly shortDescription: string;
  readonly slugLower: string;
  readonly title: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentType": "BlogArticleCardFragment";
};
export type BlogArticleCardFragment$key = {
  readonly " $data"?: BlogArticleCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogArticleCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogArticleCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugLower",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": "firstAuthor",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "BlogArticleAuthorConnection",
      "kind": "LinkedField",
      "name": "authors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EntityAvatarFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "authors(first:1)"
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_BLOG_ARTICLE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_BLOG_ARTICLE\")"
    }
  ],
  "type": "BlogArticle",
  "abstractKey": null
};

(node as any).hash = "fb43e274b5cfb10a87b050fbf4099ce6";

export default node;
